import { Dialog, DialogTitle, DialogContent, Grid2, DialogActions, Button, Box, IconButton } from '@mui/material';
import React from 'react';
import { SimpleFormField, SimpleFormPropertyType, SimpleFormTemplateProperty, useSimpleForm } from '../../../components/SimpleForm';
import { ResourceListItem } from '../../../types';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';

const ADD_MATERIAL_FORM_TEMPLATE: SimpleFormTemplateProperty<ResourceListItem>[] = [{
	name: 'name',
	label: 'Name',
	type: SimpleFormPropertyType.String,
	required: true
},{
	name: 'description',
	label: 'Secondary text',
	type: SimpleFormPropertyType.String,
},{
	name: 'quantity',
	label: 'Quantity',
	type: SimpleFormPropertyType.Number,
	required: true
},{
	name: 'uom',
	label: 'Uom',
	type: SimpleFormPropertyType.String,
	required: true,
},{
	name: 'isOptional',
	label: 'Is optional',
	type: SimpleFormPropertyType.Toggle,
}];

const ADD_TOOL_FORM_TEMPLATE: SimpleFormTemplateProperty<ResourceListItem>[] = [{
	name: 'name',
	label: 'Name',
	type: SimpleFormPropertyType.String,
	required: true
},{
	name: 'description',
	label: 'Secondary text',
	type: SimpleFormPropertyType.String,
},{
	name: 'quantity',
	label: 'Quantity',
	type: SimpleFormPropertyType.Number,
	required: true
},{
	name: 'isOptional',
	label: 'Is optional',
	type: SimpleFormPropertyType.Toggle,
}, {
	name: 'isHeavyTool',
	label: 'Is a heavy tool',
	type: SimpleFormPropertyType.Toggle,
}];

interface PlanAddMaterialDialogProps {
	open: boolean;
	onClose: () => void;
	onSubmit: (formData: Partial<ResourceListItem>) => void;
	defaultValues?: Partial<ResourceListItem>;
}

interface PlanAddToolDialogProps {
	open: boolean;
	onClose: () => void;
	onSubmit: (formData: Partial<ResourceListItem>) => void;
	defaultValues?: Partial<ResourceListItem>;
	onSearchButtonClick: () => void;
}

export function PlanAddMaterialDialog({ open, onClose, onSubmit, defaultValues }: PlanAddMaterialDialogProps) {
	const {handleFormFieldChange, hasFormChanged, getFormData} = useSimpleForm<ResourceListItem>(ADD_MATERIAL_FORM_TEMPLATE);
	
	const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();

		const formData = getFormData(e);
		if (formData) {
			onSubmit(formData);
		}
		onClose();
	};

	return <Dialog open={open} onClose={onClose}>
		<DialogTitle>Add Material</DialogTitle>
		<form onSubmit={handleSubmit}>
			<DialogContent>
				<Grid2 size={12} container spacing={1} alignContent='baseline'>
					{ADD_MATERIAL_FORM_TEMPLATE.map((property) => <Grid2 key={property.name} size={12}>
						<SimpleFormField property={property} defaultValue={defaultValues?.[property.name]} onChange={handleFormFieldChange} />
					</Grid2>)}
				</Grid2>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Cancel</Button>
				<Button type='submit' disabled={!hasFormChanged} variant='contained'>Save</Button>
			</DialogActions>
		</form>
	</Dialog>;
}

export function PlanAddToolDialog({ open, onClose, onSubmit, defaultValues, onSearchButtonClick }: PlanAddToolDialogProps) {
	const {handleFormFieldChange, hasFormChanged, getFormData} = useSimpleForm<ResourceListItem>(ADD_TOOL_FORM_TEMPLATE);

	const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		const formData = getFormData(e);
		if (formData) {
			onSubmit(formData);
		}
		onClose();
	};

	return <Dialog open={open} onClose={onClose}>
		<Box display='flex' justifyContent='space-between' alignItems='center' gap={2}>
			<DialogTitle>Add Tool</DialogTitle>
			<IconButton onClick={onSearchButtonClick} sx={{mr:1}}>
				<ManageSearchIcon />
			</IconButton>
		</Box>
		<form onSubmit={handleSubmit}>
			<DialogContent>
				<Grid2 size={12} container spacing={1} alignContent='baseline'>
					{ADD_TOOL_FORM_TEMPLATE.map((property) => <Grid2 key={property.name} size={12}>
						<SimpleFormField property={property} defaultValue={defaultValues?.[property.name]} onChange={handleFormFieldChange} />
					</Grid2>)}
				</Grid2>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Cancel</Button>
				<Button type='submit' disabled={!hasFormChanged} variant='contained'>Save</Button>
			</DialogActions>
		</form>
	</Dialog>;
}